/**
 * Build a proper youtube.com/embed URL from watch / share links.
 * String replace of watch?v= → embed/ breaks URLs with &list=… (no ? before list).
 */
export function toYoutubeEmbedUrl(raw) {
  if (!raw || typeof raw !== "string") return raw;
  const trimmed = raw.trim();
  try {
    const href = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
    const u = new URL(href);
    const host = u.hostname.replace(/^www\./i, "");

    if (host === "youtu.be") {
      const id = u.pathname.split("/").filter(Boolean)[0]?.split("?")[0];
      if (id) return `https://www.youtube.com/embed/${id}`;
      return raw;
    }

    if (host.endsWith("youtube.com")) {
      const v = u.searchParams.get("v");
      if (v) {
        const list = u.searchParams.get("list");
        const base = `https://www.youtube.com/embed/${encodeURIComponent(v)}`;
        return list ? `${base}?list=${encodeURIComponent(list)}` : base;
      }
      if (u.pathname.startsWith("/embed/")) return u.toString();
    }
  } catch {
    /* ignore */
  }
  return raw;
}
